import { render, staticRenderFns } from "./CollapsibleItem.vue?vue&type=template&id=0925b170&scoped=true&"
import script from "./CollapsibleItem.vue?vue&type=script&lang=ts&"
export * from "./CollapsibleItem.vue?vue&type=script&lang=ts&"
import style0 from "./CollapsibleItem.vue?vue&type=style&index=0&id=0925b170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0925b170",
  null
  
)

export default component.exports